import { useEffect, useRef, useState, type CSSProperties } from "react";
import { useStore } from "../store/globalState";
import { AuraLayout, Layout, Navbar, Toast } from "lola-framework-ui-test";
import { useNavigate } from "react-router-dom";
import { flavorClassName } from "../constants";
import { MailStrokeIcon, WhatsAppStrokeIcon } from "../assets/icons";

import { useSessionStore } from "../store/useSessionStore";
import { useTranslation } from "react-i18next";
import { useClaimLink } from "../hooks/useClaimLink";
import { safeCapture } from "../utils/posthog";
import { PayoutInfo } from "./transfer/flavor-c/components/PayoutInfo";
import { NavbarBackChevron } from "../components/NavbarBackChevron";

export const SupportPageV2 = () => {
  useClaimLink();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const { theme } = useStore();
  const { session } = useSessionStore();
  const colorConfig = theme.whiteView;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const viewedRef = useRef(false);
  useEffect(() => {
    if (!viewedRef.current) {
      viewedRef.current = true;
      safeCapture("ui.support.contact.screen.view");
    }
  }, []);

  const goToWhatsApp = async () => {
    safeCapture("ui.support.contact.whatsapp_button.click");
    const phone = session.data?.partner?.supportWhatsappNumber;
    if (!phone) return;
    const cleanPhone = phone.replace(/\D/g, "");
    const url = `https://wa.me/${cleanPhone}`;
    try {
      await navigator.clipboard.writeText(phone);
      setToastMessage(t("contact.whatsappCopied"));
      setShowToast(true);
    } catch (err) {
      console.warn("No se pudo copiar el número de WhatsApp", err);
    }
    window.open(url, "_blank");
  };

  const sendEmail = async () => {
    safeCapture("ui.support.contact.email_button.click");
    const email = session.data?.partner?.supportEmail;
    if (!email) return;
    const mailto = `mailto:${email}${`?subject=""`}`;
    try {
      await navigator.clipboard.writeText(email);
      setToastMessage(t("contact.emailCopied"));
      setShowToast(true);
    } catch (err) {
      console.warn("No se pudo copiar el email", err);
    }
    window.open(mailto, "_blank");
  };

  const { backgroundBtn, iconColors, title } = colorConfig;

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className={`${flavorClassName}`}
    >
        <Layout.Header>
          <NavbarBackChevron onBackClick={() => navigate(-1)}>
            <Navbar
              onBackClick={() => navigate(-1)}
              title={t("contact.title")}
              align="center"
            />
          </NavbarBackChevron>
        </Layout.Header>
      <Layout.Content className="transfer-section flavor-c">
        <section className=" payout-container payout-container-v2">
          <PayoutInfo
            title="Whatsapp"
            subtitle=""
            color={title}
            icon={
              <span
                className="icon-wrapper"
                style={{ "--bgr": backgroundBtn } as CSSProperties}
              >
                <WhatsAppStrokeIcon
                  size={24}
                  colors={iconColors}
                  className="icon-bg-br exchange-quote-info"
                />
              </span>
            }
            onChange={goToWhatsApp}
          />
          <PayoutInfo
            title="Email"
            subtitle=""
            icon={
              <span
                className="icon-wrapper"
                style={{ "--bgr": backgroundBtn } as CSSProperties}
              >
                <MailStrokeIcon
                  size={24}
                  colors={iconColors}
                  className="icon-bg-br exchange-quote-info"
                />
              </span>
            }
            onChange={sendEmail}
          />
        </section>
        <section className="toast-container">
          {showToast && (
            <Toast
              visible={showToast}
              message={toastMessage}
              duration={2000}
              type="success"
              onClose={() => setShowToast(false)}
            />
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
};
